import React, { useMemo } from 'react';

import { ClipboardProvider } from './ClipboardProvider';
import DndProvider from './DnDProvider';
import { EncryptionProvider } from './EncryptionProvider';
import { SnackbarRenderProvider } from './SnackbarRenderProvider';
import { UploadProvider } from './UploadProvider';

const ProvidersList = [
  EncryptionProvider,
  DndProvider,
  ClipboardProvider,
  UploadProvider,
  SnackbarRenderProvider,
];

export function Providers(props: React.PropsWithChildren) {
  const { children } = props;
  const components = useMemo(() => {
    let elem = children;
    for (const Provider of ProvidersList) {
      elem = <Provider>{elem}</Provider>;
    }
    return elem;
  }, [children]);

  return components;
}
